/*
 *
 * PaintPanel actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { Color } from '../../lib/modelBuilder/entities/Color';
import { CustomPiece } from '../../lib/modelBuilder/pieces/CustomPiece';
import { ComponentKewlox } from '../../lib/modelBuilder/pieces/ComponentKewlox';

export const selectPaintColorAction = (color: Color) =>
  action(ActionTypes.SELECT_COLOR, { color });

export const applyPaintColor = (
  customPiece: CustomPiece<ComponentKewlox>,
  cabinetId: string,
  shelfLevel?: number,
  rackLevel?: number,
  interShelfLevel?: number,
) =>
  action(ActionTypes.APPLY_PAINT_COLOR, {
    customPiece,
    cabinetId,
    shelfLevel,
    rackLevel,
    interShelfLevel,
  });
